import { Box, Tooltip } from '@mui/material';
import { PrimaryButton, SearchInput } from 'components/atoms';
import { noop } from 'lodash';
import React from 'react';
import { IoMdAdd } from 'react-icons/io';

import { TableHeaderProps } from './types';

export const TableHeader = ({
  onAddClick,
  disableButton = false,
  tooltip = '',
  handleSearch = noop,
  hideSearch = false,
  searchPlaceholder,
  value = '',
}: TableHeaderProps) => {
  return (
    <>
      <Box sx={{ display: 'flex', gap: 5, marginLeft: 'auto' }}>
        {!hideSearch ? (
          <SearchInput
            value={value}
            onSearch={handleSearch}
            placeholder={searchPlaceholder}
          />
        ) : null}
        <Tooltip title={disableButton ? tooltip : null} placement="top">
          <span style={{ maxWidth: '100%', minHeight: '100%' }}>
            <PrimaryButton
              data-testid="table-add-button"
              disabled={disableButton}
              onClick={onAddClick}
              style={{ minHeight: '100%' }}
            >
              <IoMdAdd style={{ fontSize: '1.5rem' }} />
            </PrimaryButton>
          </span>
        </Tooltip>
      </Box>
    </>
  );
};
